import { CheckmarkSmIcon } from '@crono-one/design-system';

interface OptionRadioMarkProps {
  selected: boolean;
  /** Ring of an unselected option; tick of a selected one, cut out of white. */
  color?: string;
}

/** Radio mark at the end of a status or stage option. */
export function OptionRadioMark({ selected, color }: OptionRadioMarkProps) {
  if (selected) {
    return (
      <span
        aria-hidden
        className="ml-auto grid size-5 shrink-0 place-content-center rounded-full bg-white"
        style={{ color }}
      >
        <CheckmarkSmIcon className="size-3.5" />
      </span>
    );
  }
  return (
    <span
      aria-hidden
      className="ml-auto size-5 shrink-0 rounded-full border-2"
      style={{ borderColor: color }}
    />
  );
}
